var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('navigation-ui',{attrs:{"media-url":_vm.mediaUrl}},[_c('bp-ads-super-banner',{staticClass:"hidden-mobile"}),_vm._v(" "),_c('nuxt'),_vm._v(" "),_c('sd-container',[_c('seo-breadcrumb'),_vm._v(" "),_c('feedback-widget')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }